import Aura from "@primeuix/themes/aura";
import { definePreset, palette } from "@primeuix/themes";
const Mytheme=definePreset(Aura,{
    semantic: {
         primary:palette('{blue}'),
    },
    
        
    components:{
        menubar:{
             colorScheme:{
                light:{
                    root:{
                        background:"{primary.500}",
                        color:"{primary.500}",
                    },
                    item:{
                        color:'#fff'
                    }
                },
            
             dark:{
                root:{
                    background:"{surface.500}",
                    color:"{primary.500}",
                }
             
             }
            },
        },
        paginator:{
            navButton:{
                background:"#fff",
                hoverBackground:"{surface-0}",
                selectedBackground:"{surface-0}",
                hoverColor:"{primary-600}",
                selectedColor:"{primary-600}" 
            }
        },
        accordion:{
            header:{
                color:"{primary-600}",
                activeColor:"{primary-600}"
            }
        },
        inputtext:{
            root:{
                borderColor:"{neutral-400}",
                color:"{neutral-800}",
                hoverBorderColor:"{primary-600}",
                focusBorderColor:"{primary-color}",
                
                shadow:"none",
               // borderRadius:""
            }
        },
        select:{

            root:{
                borderColor:"{neutral-400}",
                color:"{neutral-800}",
                hoverBorderColor:"{primary-600}",
                focusBorderColor:"{primary-color}",
                
                shadow:"none",
            }
        },
        textarea:{

            root:{
                borderColor:"{neutral-400}",
                color:"{neutral-800}",
                hoverBorderColor:"{primary-600}",
                focusBorderColor:"{primary-color}",
                
                shadow:"none",
            }
        },
        button:{
           colorScheme:{
            light:{
                root:{                   
                    primary:{
                        background:"{primary-600}",
                        hoverBackground:"{primary-600}",
                        activeBackground:"{primary-600}",
                        borderColor:"{primary-600}",
                        hoverBorderColor:"{primary-600}",
                        activeBorderColor:"{primary-600}",
                        color:"#fff",
                        hoverColor:"#fff",
                        activeColor:"#fff",
                        

                    },
                    secondary:{
                        background:"transparent",
                        hoverBackground:"transparent",
                        activeBackground:"transparent",
                        borderColor:"{neutral-400}",
                        hoverBorderColor:"{neutral-500}",
                        activeBorderColor:"{neutral-500}",
                        color:"{neutral-500}",
                        hoverColor:"{neutral-700}",
                        activeColor:"{neutral-700}"
                    },
                
                  
                },
                link:{
                    color:"{primary-600}",
                    hoverColor:"{primary-600}",
                    activeColor:"{primary-600}"
                },
                outlined:{
                    primary:{
                        borderColor:'{primary-600}',
                        activeBackground:'#fff',
                        hoverBackground:'{primary-100}',
                        color:'{primary-600}',
                        //hoverColor:"#fff"
                        
                    },
                    secondary:{
                        borderColor:"{neutral-500}",
                        activeBackground:'#fff',
                        hoverBackground:'#fff',
                        color:'{neutral-500}',
                        //hoverColor:'#fff'
                    }
                }
            },
            dark:{

            }
           }
        },        
        datatable:{
           colorScheme:{
            light:{
                root:{
                  borderColor:"{surface.200}"
                },
                header:{
                    background:"#ccc",
                    color:"{text-color}"
                },
                headerCell:{
                    background:"#f4f4f4",
                    hoverBackground:"#f4f4f4",
                    borderColor:"#f4f4f4",
                    hoverColor:"#9e9ea2"
                    
                },
                sortIcon:{
                    color:"#9e9ea2"
                },
                row:{
                    color:"#333"
                }
            }
           }
        }
    }


}
 )

export default Mytheme;